import PropTypes from 'prop-types';
import React from 'react';
import {
    EXPERIAN_VALIDATION_VALID,
    EXPERIAN_VALIDATION_INVALID,
    EXPERIAN_VALIDATION_LOADING
} from './../../constants';

class ValidationIcons extends React.Component {

    static propTypes = {
        renderState: PropTypes.string
    };

    static defaultProps = {
        renderState: EXPERIAN_VALIDATION_LOADING
    };

    render() {
        switch (this.props.renderState) {
            case EXPERIAN_VALIDATION_INVALID :
                return (
                    <span className='validation-icons loaded'>
                        <span className='la-Incorrect'></span>
                    </span>
                );
            case EXPERIAN_VALIDATION_VALID :
                return (
                    <span className='validation-icons loaded'>
                        <span className='la-Correct'></span>
                    </span>
                );
            default :
                return (
                    <span className='validation-icons loading'>

                    </span>
                )
        }

    }

}

export default ValidationIcons;


// WEBPACK FOOTER //
// ./src/scripts/reusable/ValidationIcons/ValidationIcons.jsx